import { onBeforeUnmount, ref, watch } from 'vue';
function useTableSelection(tableData, params) {
    const option = Object.assign({ key: 'id', cache: false }, params !== null && params !== void 0 ? params : {});
    const isSelectedAll = ref(false);
    const isIndeterminate = ref(false);
    const selectedRowKeys = ref([]);
    const selectAll = () => {
        if (isSelectedAll.value) {
            if (option.cache) {
                const ids = tableData.value.map(d => d[option.key]).filter(k => !selectedRowKeys.value.includes(k));
                selectedRowKeys.value.push(...ids);
            }
            else {
                selectedRowKeys.value.splice(0, selectedRowKeys.value.length);
                selectedRowKeys.value.push(...tableData.value.map(d => d[option.key]));
            }
            isIndeterminate.value = false;
        }
        else {
            if (option.cache) {
                tableData.value.forEach(d => {
                    const idx = selectedRowKeys.value.indexOf(d[option.key]);
                    idx > -1 && selectedRowKeys.value.splice(idx, 1);
                });
            }
            else {
                selectedRowKeys.value.splice(0, selectedRowKeys.value.length);
            }
        }
    };
    const selectRow = () => {
        if (option.cache) {
            doSelectionStatus();
        }
        else {
            isSelectedAll.value = selectedRowKeys.value.length === tableData.value.length;
            if (selectedRowKeys.value.length > 0 && isSelectedAll.value == false) {
                isIndeterminate.value = true;
            }
            else {
                isIndeterminate.value = false;
            }
        }
    };
    const doSelectionStatus = () => {
        const selectedItems = tableData.value.filter(item => selectedRowKeys.value.includes(item[option.key]));
        if ((selectedItems.length <= selectedRowKeys.value.length) && (selectedItems.length === tableData.value.length)) {
            isSelectedAll.value = true;
            isIndeterminate.value = false;
        }
        else if (selectedItems.length === 0) {
            isSelectedAll.value = false;
            isIndeterminate.value = false;
        }
        else {
            isSelectedAll.value = false;
            isIndeterminate.value = true;
        }
    };
    const watchHandler = watch(tableData, () => {
        if (option.cache) {
            doSelectionStatus();
        }
        else {
            selectedRowKeys.value.splice(0, selectedRowKeys.value.length);
            isSelectedAll.value = false;
            isIndeterminate.value = false;
        }
    });
    onBeforeUnmount(() => {
        watchHandler && watchHandler();
    });
    return {
        isSelectedAll,
        isIndeterminate,
        selectedRowKeys,
        selectAll,
        selectRow,
    };
}
export { useTableSelection };
